export default function LoaderElement() {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  )
}